import React, { FC, useContext } from 'react'
import { AboutContext } from '../../../contexts/aboutProvider'
import { clearHtml, slideDown, slideUp } from '../../../lib/utils'
import Title from '../../common/Title/Title'
import css from './AboutPage.module.scss'
import Image from '../../common/Image/Image'
import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import cx from 'classnames'
import Player from '../../common/Player/Player'
import { ImageTicker } from '../../common/ImageTicker/ImageTicker'

const AboutPage: FC = () => {
  const {
    title,
    subtitle,
    description,
    content,
    topPicture,
    video,
    code,
    partners,
  } = useContext(AboutContext)

  const accordionHandler = (e: any) => {
    const target = e.target
    if (target.tagName === 'LABEL') {
      if (target.classList.contains('active')) {
        slideUp(target.nextElementSibling)
        target.classList.remove('active')
      } else {
        slideDown(target.nextElementSibling)
        target.classList.add('active')
      }
    }
  }

  const renderHeader = (code) => {
    switch (code) {
      case 'company':
        return (
          <MaxWidth mobileWide>
            <section className={css.top}>
              <div className={css.heading}>
                <Title big>{title}</Title>

                {subtitle && <h3 className={css.subheading}>{subtitle}</h3>}

                {description && (
                  <div
                    dangerouslySetInnerHTML={{ __html: clearHtml(description) }}
                  />
                )}
              </div>
              {topPicture && (
                <figure className={css.image}>
                  <Image
                    src={topPicture}
                    layout="responsive"
                    width={655}
                    height={745}
                    loading="eager"
                    objectFit="cover"
                    priority
                  />
                </figure>
              )}
            </section>
          </MaxWidth>
        )
      case 'cosmetics':
        return (
          <>
            <MaxWidth mobileWide className={css.cosmetics_top}>
              <Title>{title}</Title>
              <figure className={css.cover}>
                <Image
                  src={topPicture}
                  alt="О косметике"
                  layout="responsive"
                  width={1380}
                  height={495}
                  loading="eager"
                  objectFit="cover"
                  priority
                />
              </figure>
            </MaxWidth>
            {(subtitle || description) && (
              <MaxWidth mobileWide>
                <section className={css.about}>
                  {subtitle && <h3>{subtitle}</h3>}
                  {description && (
                    <div
                      className={css.about_description}
                      dangerouslySetInnerHTML={{
                        __html: clearHtml(description),
                      }}
                    />
                  )}
                </section>
              </MaxWidth>
            )}
          </>
        )
      default:
        return <Title>{title}</Title>
    }
  }

  const renderBlock = (contentItem, index: number) => {
    const key = `about-page-block-${
      contentItem.code ? contentItem.code : index
    }`

    switch (contentItem.code) {
      case 'blockquote':
      case 'timeline':
      case 'about_description_section':
        return (
          <MaxWidth key={key}>
            <div
              className={css[contentItem.code]}
              dangerouslySetInnerHTML={{
                __html: clearHtml(contentItem.contents),
              }}
            />
          </MaxWidth>
        )

      case 'structure':
        return (
          <React.Fragment key={key}>
            {video && (
              <MaxWidth mobileWide>
                <Player {...video} />
              </MaxWidth>
            )}
            <MaxWidth key={key} className={css.structure_wrapper}>
              <div
                onClick={accordionHandler}
                className={cx(css[contentItem.code], 'common')}
                dangerouslySetInnerHTML={{
                  __html: clearHtml(contentItem.contents),
                }}
              />
            </MaxWidth>
          </React.Fragment>
        )

      case 'policy':
      case 'fw-image':
      case 'advantages':
        return (
          <MaxWidth mobileWide key={key}>
            <div
              className={css[contentItem.code]}
              dangerouslySetInnerHTML={{
                __html: clearHtml(contentItem.contents),
              }}
            />
          </MaxWidth>
        )
      default:
        return (
          <MaxWidth mobileWide key={key}>
            <div
              dangerouslySetInnerHTML={{
                __html: clearHtml(contentItem.contents),
              }}
            />
          </MaxWidth>
        )
    }
  }
  return (
    <div className={css.wrapper}>
      {renderHeader(content.code)}

      {content?.contents?.map((item, index) => renderBlock(item, index))}

      {code === 'company' && (
        <ImageTicker isBig items={partners} className={css.ticker} />
      )}

      {video && code === 'company' && (
        <MaxWidth mobileWide>
          <Player {...video} />
        </MaxWidth>
      )}
    </div>
  )
}

export default AboutPage
